<script lang="ts">
	import BaseNode from './BaseNode.svelte';
	import { devices, rooms } from '../../../stores';
	import { resolveDeviceInStore } from '../helpers/resolveDeviceInStore';
	import type { FlowNode, NodeData } from '../types/flow-types';
	import { getEffectiveNodeDisplayLabel } from '../PropertyEditors/helpers/LabelGenerator';
	import { kelvin_to_rgb } from '../../../helpers/utilities';

	export let id: string;
	export let data: NodeData;
	export let selected: boolean = false;
	export let validated: boolean = true;
	export let errors: string[] = [];

	$: displayText = (() => {
		$devices;
		return getEffectiveNodeDisplayLabel({
			id,
			type: 'action',
			position: { x: 0, y: 0 },
			data,
			validated,
			errors,
		} as FlowNode);
	})();

	$: colorLabel = (() => {
		const actions = Array.isArray(data.actions) ? (data.actions as any[]) : [];

		const r = actions.find((a) => a.name === 'r')?.value;
		const g = actions.find((a) => a.name === 'g')?.value;
		const b = actions.find((a) => a.name === 'b')?.value;
		if (r != null && g != null && b != null) {
			return `rgb(${r},${g},${b})`;
		}

		const ct = actions.find((a) => a.name === 'ct' || a.name === 'temp')?.value;
		if (ct != null) {
			const [kr, kg, kb] = kelvin_to_rgb(ct);
			return `rgb(${Math.round(kr)},${Math.round(kg)},${Math.round(kb)})`;
		}

		return null;
	})();
	$: actionDeviceId = String(
		(data as any).device?.id ??
			(data as any).deviceId ??
			(data as any).sceneCapability?.deviceId ??
			'',
	);
	$: actionChannel = Number((data as any).device?.channel ?? (data as any).channel ?? 0) || 0;
	$: actionDevice = actionDeviceId
		? (resolveDeviceInStore($devices, actionDeviceId, actionChannel) as any)
		: undefined;
	$: actionRoom = String(
		($rooms as any)?.[actionDevice?.room_id]?.name ?? actionDevice?.room_name ?? '',
	).trim();
	$: actionTitle = actionDevice
		? `${actionDevice.name || actionDeviceId}${actionRoom ? ` · ${actionRoom}` : ''}`
		: undefined;
</script>

{#if colorLabel}
	<BaseNode
		{id}
		type="action"
		{data}
		{selected}
		{validated}
		{errors}
		sentence={displayText}
		cardTitle={actionTitle}
		nodeTypeLabel="Device action"
		{...$$restProps}
	>
		<div class="action-content">
			<span class="color-swatch" style="background: {colorLabel};" title={colorLabel}></span>
		</div>
	</BaseNode>
{:else}
	<BaseNode
		{id}
		type="action"
		{data}
		{selected}
		{validated}
		{errors}
		sentence={displayText}
		cardTitle={actionTitle}
		nodeTypeLabel="Device action"
		{...$$restProps}
	/>
{/if}

<style>
	.action-content {
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		gap: 6px;
	}

	.color-swatch {
		display: inline-block;
		width: 12px;
		height: 12px;
		border-radius: 50%;
		border: 1.5px solid rgba(15, 23, 42, 0.2);
		flex-shrink: 0;
		align-self: center;
	}
</style>
